"use client";

import React from "react";
import { Plus, Minus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "How is the security of my legal documentation ensured?",
  answer: "Our firm utilizes enterprise-grade encryption and strict physical access controls to ensure your sensitive legal documents remain confidential and protected at all times. Every transaction is logged and monitored to maintain absolute integrity."
}, {
  question: "What are the typical timelines for mortgage processing?",
  answer: "While timelines vary by complexity, most mortgage applications are processed within 15 to 30 days. We provide weekly status updates and a dedicated point of contact to keep you informed of every milestone in your property acquisition."
}, {
  question: "Are there any hidden fees in the consultation process?",
  answer: "Transparency is our priority. All fees are clearly outlined in our initial engagement letter, including potential disbursements and third-party costs, ensuring no unexpected financial obligations arise during the course of our representation."
}, {
  question: "How do you maintain client confidentiality during cases?",
  answer: "We adhere to the highest standards of legal privilege and data protection. All staff undergo rigorous confidentiality training, and our digital systems are audited regularly for compliance with international privacy regulations and legal standards."
}];
export default function QuestionsAndAnswers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="198807" id="frequently-asked-questions" className="bg-primary py-[200px] text-primary-foreground">
      <div ref={ref} className={cn("mx-auto flex w-full max-w-3xl flex-col items-center px-4 transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0")}>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-white/10 rounded-none">
              <AccordionTrigger className="group flex items-center justify-between py-6 text-left hover:no-underline rounded-none [&>svg]:hidden">
                <span className="pr-8 text-2xl font-default font-bold text-primary-foreground transition-colors duration-300 group-data-[state=open]:text-chart-3">
                  {faq.question}
                </span>
                <div className="shrink-0 text-primary-foreground group-data-[state=open]:text-chart-3">
                  <Plus className="size-6 stroke-[1px] transition-transform duration-300 group-data-[state=open]:hidden" />
                  <Minus className="hidden size-6 stroke-[1px] transition-transform duration-300 group-data-[state=open]:block" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-8 pt-2 text-base leading-[1.7] text-muted-foreground font-default">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <Button className="mt-16 h-14 rounded-none bg-chart-3 px-10 text-sm font-medium uppercase tracking-widest text-primary transition-colors hover:bg-chart-3/90">
          Request Consultation
        </Button>
      </div>
    </section>;
}